import React from "react";
import withMotion from "../../../../Utils/withMotion";
import Sidebar from "../../Sidebar/Sidebar";
import "../../Blog.scss";
import { Link } from "react-router-dom";

//Utils
import { mapBlogs } from "../../Pagination/utils";

//Images
import banner from "../../images/permeablePaverManufacturers/permeable-paving-manufacturers-banner.jpg";
// import img001 from "../../images/permeablePaverManufacturers/blog-paver-manufacturers-001.jpg";
import img002 from "../../images/permeablePaverManufacturers/blog-paver-manufacturers-002.jpg";
import img003 from "../../images/permeablePaverManufacturers/blog-paver-manufacturers-003.jpg";

// SEO
import SEO from "../../../../SEO/index.js";
import StructuredData from "../../../../SEO/structuredData";
import { ViewPavers } from "../../../../CTA/CTA";

export const PermeablePaverManufacturersData = {
  title:
    "Our Favorite Permeable Paving Manufacturers for Landscapes and Streetscapes",
  image: banner,
  destination:
    "/blog/favorite-permeable-paving-manufacturers-landscapes-streetscapes",
  date: "August 21, 2016",
  categories: ["blog", "paving-stones", "permeable-pavers"],
};

const PermeablePaverManufacturers = () => {
  const blog = [PermeablePaverManufacturersData];

  return (
    <>
      <SEO
        title="The Top Permeable Paving Manufacturers in Southern California"
        description="There are dozens of Permeable Paving manufacturing brands to choose from in Southern California. Here are just a few of our favorite permeable paving manufacturers:"
        profileURL={
          "https://www.pacificpavingstone.com/blog/favorite-permeable-paving-manufacturers-landscapes-streetscapes"
        }
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org/",
          "@type": "BlogPosting",
          author: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
          URL: "https://www.pacificpavingstone.com/blog/favorite-permeable-paving-manufacturers-landscapes-streetscapes",
          headline:
            "The Top Permeable Paving Manufacturers in Southern California",
          description:
            "There are dozens of Permeable Paving manufacturing brands to choose from in Southern California. Here are just a few of our favorite permeable paving manufacturers.",
          image: {
            "@type": "ImageObject",
            url: "https://www.pacificpavingstone.com/static/media/permeable-paving-manufacturers-banner.af544b85.jpg",
          },
          datePublished: "2016-08-21",
          publisher: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
        }}
      />
      <div className="container-fluid page-blog">
        <div className="row justify-content-center">
          <div className="col-11 col-lg-6">
            {mapBlogs(1, blog, true)}
            <p>
              In the past few decades, the Environmental Protection Agency (EPA)
              and many local municipalities have mandated guidelines to help
              manage stormwater runoff. This movement has paved the path for
              innovative products like permeable pavers.
            </p>

            <p>
              Permeable paving manufacturers have created paving stones much
              like those used in traditional applications for driveways and
              other surfaces. These permeable paving stones offer an attractive
              and functional surface while being sensitive to the environment.
            </p>

            <p>
              Traditional paved surfaces are impervious which creates a
              substantial challenge when dealing with their contribution to
              stormwater runoff. On some Southern California properties, the
              need to use materials by permeable paving manufacturers narrows
              choices of materials.
            </p>

            <p>
              Your property has a maximum amount of impervious space allowed to
              abide by stormwater management guidelines. If you reach your limit
              and still want to add more paved surfaces, permeable paving
              manufacturers offer a great alternative product.
            </p>

            <h4>How Permeable Pavers Work</h4>
            <p>
              Products from permeable paving manufacturers make it possible to
              add driveways, patios, and other hard surfaces to your Los Angeles
              property while not creating more impervious areas. Not only are
              there large gaps between permeable pavers, but the paving stones
              are just one part of a whole system that is engineered to seep
              down to the groundwater below versus running off.
            </p>

            <p>
              The area is excavated, then filled with coarse gravel. The
              permeable pavers are laid on top of this base. These special
              pavers also have larger joints between them which are filled with
              small, pea gravel.
            </p>

            <p>
              This allows any surface water to travel through the paved area to
              the water table below versus down the street and into a storm
              drain. Permeable pavers mimic the way natural land absorbs
              stormwater.
            </p>

            <p className="text-center text-blue">
              Check out our video about how permeable pavers work!{" "}
            </p>
            <iframe
              width="100%"
              height="560"
              src="https://www.youtube.com/embed/Q-jrPCjDeZI"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="Pavers"
            ></iframe>
            <h4>
              Benefits of Using Products from Permeable Paving Manufacturers
            </h4>
            <ul>
              <li> Reduces erosion</li>
              <li>
                Minimizes reflecting heat if light-colored pavers are selected
              </li>
              <li>Reduces standing water areas where mosquitoes breed</li>
              <li>
                Permeable paver areas last longer than poured concrete, clay
                bricks, or asphalt
              </li>
              <li>Filters water back to local groundwater supplies</li>
              <li>
                Lowers the amount of water needed for landscaping plants and
                turf areas
              </li>
              <li>
                Allows for the possibility of retaining and storing stormwater
                to be reused for irrigation sources or for non-potable uses (if
                additional systems are installed underneath)
              </li>
              <li>Reduces nonpoint source pollutants in stormwater</li>
              <li>Lessens downstream flooding</li>
              <li>
                Pavers from permeable paving manufacturers minimizes stresses on
                municipal sewer systems
              </li>
              <li>May decrease project costs and even some utility bills</li>
            </ul>
            <h4>Our Favorite Permeable Paving Manufacturers</h4>
            <p>
              There are dozens of brands to choose from. Each brand offers
              slightly unique shapes, textures, and color combinations. Here at
              Pacific Pavingstone, we’ve installed millions of pavers on tens of
              thousands of properties. Here are just a few of our favorite
              permeable paving manufacturers:
            </p>
            <div className="row justify-content-center">
              <div className="col-md-3">
                <img src={img002} alt="" />
              </div>
              <div className="col-md-9">
                <h4>Angelus Paving Stones</h4>
                <p>
                  Since 1946, Angelus has been one of the leading permeable
                  paving manufacturers. Their wide variety of permeable paver
                  colors, textures and styles provides many versatile design
                  solutions.
                </p>
                <p>
                  This manufacturer is a great choice to consider if adding
                  permeable pavers for a new driveway on your Southern
                  California property.
                </p>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-3">
                <img src={img003} alt="" />
              </div>
              <div className="col-md-9">
                <h4>Belgard</h4>
                <p>
                  Whether your project calls for an old world feel, a modern
                  flair, or a casual style,{" "}
                  <a
                    href="https://www.belgard.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Belgard
                  </a>{" "}
                  offers a great array of permeable pavers in various color
                  blends.
                </p>

                <p>
                  Coming to the market in the mid 1990’s, Belgard has proven to
                  be a force to be reckoned with among permeable paving
                  manufacturers. Their product guides and image catalogs are a
                  great resource for the Los Angeles resident planning their new
                  permeable driveway.
                </p>
              </div>
            </div>

            <h4>Help with Choosing Between Permeable Paving Manufacturers</h4>
            <p>
              One of the most exciting parts of planning a new permeable paver
              project, or any landscape design is the material selection
              process. The team of landscape designers at Pacific Pavingstone
              have decades of hands-on experience of working with many permeable
              paving manufacturers.
            </p>

            <p>
              After tens of thousands of successful installations, we still know
              that every property and its owner is unique. Whether it’s browsing
              through permeable paving manufacturer catalogs, seeing physical
              samples, or seeing examples of projects we’ve completed, we can
              help you.
            </p>

            <p>
              <Link to="/contact-us">
                Feel free to contact us for a free consultation!
              </Link>{" "}
              Whether traditional paving stones or permeable pavers are
              required, we are here to help you every step of the way.
            </p>
            <ViewPavers/>
          </div>
          <Sidebar />
        </div>
      </div>
    </>
  );
};

export default withMotion(PermeablePaverManufacturers);
